export const accommodation_facilities = {
  2: {
    label: "Parcheggio",
    icon: ""
  },
  3: {
    label: "Ristorante",
    icon: ""
  },
  4: {
    label: "Animali ammessi",
    icon: ""
  },
  5: {
    label: "Servizio in camera",
    icon: ""
  },
  6: {
    label: "Spazi per riunioni banchetti",
    icon: ""
  },
  7: {
    label: "Bar",
    icon: ""
  },
  8: {
    label: "Reception 24 ore su 24",
    icon: ""
  },
  9: {
    label: "Campo da tennis",
    icon: ""
  },
  10: {
    label: "Sauna",
    icon: ""
  },
  11: {
    label: "Palestra",
    icon: ""
  },
  12: {
    label: "Campo da golf (nel raggio di 3 km)",
    icon: ""
  },
  14: {
    label: "Giardino",
    icon: ""
  },
  15: {
    label: "Terrazza",
    icon: ""
  },
  16: {
    label: "Camere non fumatori",
    icon: ""
  },
  17: {
    label: "Navetta aeroportuale",
    icon: ""
  },
  19: {
    label: "Pesca",
    icon: ""
  },
  20: {
    label: "Centro business",
    icon: ""
  },
  21: {
    label: "Servizio baby-sitter",
    icon: ""
  },
  22: {
    label: "Servizio lavanderia",
    icon: ""
  },
  23: {
    label: "Lavaggio a secco",
    icon: ""
  },
  24: {
    label: "Colazione continentale",
    icon: ""
  },
  25: {
    label: "Camere strutture per ospiti disabili",
    icon: ""
  },
  26: {
    label: "Sci",
    icon: ""
  },
  27: {
    label: "Parrucchiere salone di bellezza",
    icon: ""
  },
  28: {
    label: "Disponibilità di camere familiari",
    icon: ""
  },
  29: {
    label: "Sala giochi",
    icon: ""
  },
  30: {
    label: "Sala casinò",
    icon: ""
  },
  43: {
    label: "Possibilità di colazione in camera",
    icon: ""
  },
  44: {
    label: "Servizio stireria",
    icon: ""
  },
  46: {
    label: "Parcheggio gratuito",
    icon: ""
  },
  47: {
    label: "Connessione internet",
    icon: ""
  },
  48: {
    label: "Ascensore",
    icon: ""
  },
  49: {
    label: "Check-in e check-out express",
    icon: ""
  },
  50: {
    label: "Solarium",
    icon: ""
  },
  51: {
    label: "Cassaforte",
    icon: ""
  },
  52: {
    label: "Servizio di parcheggio e riconsegna auto",
    icon: ""
  },
  53: {
    label: "Cambio valuta",
    icon: ""
  },
  54: {
    label: "Spa & centro benessere",
    icon: ""
  },
  55: {
    label: "Massaggi",
    icon: ""
  },
  56: {
    label: "Area giochi",
    icon: ""
  },
  57: {
    label: "Biliardo",
    icon: ""
  },
  58: {
    label: "Ping-pong",
    icon: ""
  },
  59: {
    label: "Karaoke",
    icon: ""
  },
  61: {
    label: "Windsurf",
    icon: ""
  },
  62: {
    label: "Freccette",
    icon: ""
  },
  63: {
    label: "Vasca idromassaggio jacuzzi",
    icon: ""
  },
  64: {
    label: "Disponibilità di camere insonorizzate",
    icon: ""
  },
  69: {
    label: "Canoa",
    icon: ""
  },
  70: {
    label: "Escursionismo",
    icon: ""
  },
  71: {
    label: "Cappella o luogo di culto",
    icon: ""
  },
  72: {
    label: "Barbecue",
    icon: ""
  },
  73: {
    label: "Possibilità di pranzo al sacco",
    icon: ""
  },
  75: {
    label: "Autonoleggio",
    icon: ""
  },
  76: {
    label: "Escursioni in bicicletta",
    icon: ""
  },
  77: {
    label: "Bowling",
    icon: ""
  },
  78: {
    label: "Banco escursioni",
    icon: ""
  },
  79: {
    label: "Hammam",
    icon: ""
  },
  80: {
    label: "Riscaldamento",
    icon: ""
  },
  81: {
    label: "Fax fotocopiatrice",
    icon: ""
  },
  82: {
    label: "Immersioni subacquee",
    icon: ""
  },
  86: {
    label: "Equitazione",
    icon: ""
  },
  87: {
    label: "Squash",
    icon: ""
  },
  90: {
    label: "Snorkeling",
    icon: ""
  },
  91: {
    label: "Deposito bagagli",
    icon: ""
  },
  96: {
    label: "WiFi",
    icon: ""
  },
  97: {
    label: "Minigolf",
    icon: ""
  },
  99: {
    label: "Deposito sci",
    icon: ""
  },
  100: {
    label: "Scuola di sci",
    icon: ""
  },
  101: {
    label: "Camera anallergica",
    icon: ""
  },
  103: {
    label: "Piscina coperta",
    icon: ""
  },
  104: {
    label: "Piscina all'aperto",
    icon: ""
  },
  107: {
    label: "Connessione WiFi gratuita",
    icon: ""
  },
  108: {
    label: "Struttura interamente non fumatori",
    icon: ""
  },
  109: {
    label: "Aria condizionata",
    icon: ""
  },
  110: {
    label: "Area fumatori",
    icon: ""
  },
  111: {
    label: "Sportello bancomat",
    icon: ""
  },
  114: {
    label: "Spiaggia privata",
    icon: ""
  },
  115: {
    label: "Ristorante (à la carte)",
    icon: ""
  },
  116: {
    label: "Ristorante (a buffet)",
    icon: ""
  },
  117: {
    label: "Snack bar",
    icon: ""
  },
  118: {
    label: "Terrazza solarium",
    icon: ""
  },
  119: {
    label: "Piscina all'aperto (tutto l'anno)",
    icon: ""
  },
  120: {
    label: "Piscina all'aperto (stagionale)",
    icon: ""
  },
  121: {
    label: "Piscina al coperto (tutto l'anno)",
    icon: ""
  },
  122: {
    label: "Piscina al coperto (stagionale)",
    icon: ""
  },
  124: {
    label: "Servizio concierge",
    icon: ""
  },
  125: {
    label: "Staff di animazione",
    icon: ""
  },
  126: {
    label: "Locale notturno DJ",
    icon: ""
  },
  127: {
    label: "Check-in e check-out privati",
    icon: ""
  },
  128: {
    label: "Servizio navetta (gratuito)",
    icon: ""
  },
  129: {
    label: "Servizio navetta (a pagamento)",
    icon: ""
  },
  130: {
    label: "Noleggio attrezzatura sciistica sul posto",
    icon: ""
  },
  131: {
    label: "Vendita skipass",
    icon: ""
  },
  132: {
    label: "Accesso immediato su pista da sci",
    icon: ""
  },
  133: {
    label: "Menù per diete particolari (su richiesta)",
    icon: ""
  },
  134: {
    label: "Stirapantaloni",
    icon: ""
  },
  135: {
    label: "Distributore automatico di bevande",
    icon: ""
  },
  136: {
    label: "Distributore automatico di snack",
    icon: ""
  },
  137: {
    label: "Attrezzature per sport acquatici sul posto",
    icon: ""
  },
  138: {
    label: "Vasca termale",
    icon: ""
  },
  139: {
    label: "Navetta aeroportuale (gratuita)",
    icon: ""
  },
  140: {
    label: "Navetta aeroportuale (a pagamento)",
    icon: ""
  },
  141: {
    label: "Cucina in comune",
    icon: ""
  },
  142: {
    label: "Armadietti",
    icon: ""
  },
  143: {
    label: "Sala comune zona TV",
    icon: ""
  },
  144: {
    label: "Mini club",
    icon: ""
  },
  145: {
    label: "Minimarket sul posto",
    icon: ""
  },
  146: {
    label: "Fronte spiaggia",
    icon: ""
  },
  147: {
    label: "Intrattenimento serale",
    icon: ""
  },
  148: {
    label: "Parco acquatico",
    icon: ""
  },
  149: {
    label: "Solo per adulti",
    icon: ""
  },
  158: {
    label: "Servizio pulizie giornaliero",
    icon: ""
  },
  159: {
    label: "Consegna spesa a domicilio",
    icon: ""
  },
  160: {
    label: "Parcheggio sul posto",
    icon: ""
  },
  161: {
    label: "Parcheggio privato",
    icon: ""
  },
  162: {
    label: "Parcheggio misto",
    icon: ""
  },
  163: {
    label: "WiFi disponibile ovunque",
    icon: ""
  },
  164: {
    label: "WiFi a pagamento",
    icon: ""
  },
  166: {
    label: "Vasca all'aperto",
    icon: ""
  },
  167: {
    label: "Vasca comune",
    icon: ""
  },
  168: {
    label: "Scivolo d'acqua",
    icon: ""
  },
  169: {
    label: "Giochi da piscina",
    icon: ""
  },
  170: {
    label: "Giochi da tavolo puzzle",
    icon: ""
  },
  172: {
    label: "Area giochi al coperto",
    icon: ""
  },
  173: {
    label: "Area giochi all'aperto",
    icon: ""
  },
  174: {
    label: "Cancelletti di sicurezza per bambini",
    icon: ""
  },
  176: {
    label: "Pasti per bambini",
    icon: ""
  },
  177: {
    label: "Buffet per bambini",
    icon: ""
  },
  180: {
    label: "Parcheggio in strada",
    icon: ""
  },
  181: {
    label: "Autorimessa",
    icon: ""
  },
  182: {
    label: "Stazione di ricarica per veicoli elettrici",
    icon: ""
  },
  183: {
    label: "Biglietti per i mezzi di trasporto",
    icon: ""
  },
  184: {
    label: "Parcheggio per disabili",
    icon: ""
  },
  185: {
    label: "Accesso su sedia a rotelle",
    icon: ""
  },
  186: {
    label: "WC con maniglioni",
    icon: ""
  },
  187: {
    label: "WC con seduta più alta",
    icon: ""
  },
  188: {
    label: "Lavabo più basso",
    icon: ""
  },
  189: {
    label: "Campanello di emergenza nel bagno",
    icon: ""
  },
  192: {
    label: "Piscina all'ultimo piano",
    icon: ""
  },
  193: {
    label: "Infinity pool",
    icon: ""
  },
  194: {
    label: "Piscina con vista",
    icon: ""
  },
  195: {
    label: "Piscina riscaldata",
    icon: ""
  },
  196: {
    label: "Piscina di acqua salata",
    icon: ""
  },
  197: {
    label: "Vasca immersione ad acqua fredda",
    icon: ""
  },
  199: {
    label: "Bar a bordo piscina",
    icon: ""
  },
  200: {
    label: "Zona acqua bassa",
    icon: ""
  },
  201: {
    label: "Copertura per piscina",
    icon: ""
  },
  203: {
    label: "Vino champagne",
    icon: ""
  },
  205: {
    label: "Frutta",
    icon: ""
  },
  209: {
    label: "Navetta dall'aeroporto",
    icon: ""
  },
  210: {
    label: "Navetta per l'aeroporto",
    icon: ""
  },
  211: {
    label: "Ausili visivi: Braille",
    icon: ""
  },
  212: {
    label: "Ausili visivi: segnaletica tattile",
    icon: ""
  },
  213: {
    label: "Segnali uditivi",
    icon: ""
  },
  214: {
    label: "Passeggini",
    icon: ""
  },
  215: {
    label: "Attrezzatura da tennis",
    icon: ""
  },
  216: {
    label: "Attrezzatura da badminton",
    icon: ""
  },
  217: {
    label: "Ceste per animali domestici",
    icon: ""
  },
  218: {
    label: "Ciotole per animali domestici",
    icon: ""
  },
  219: {
    label: "Caffetteria sul posto",
    icon: ""
  },
  220: {
    label: "Sdraio lettini",
    icon: ""
  },
  221: {
    label: "Ombrelloni",
    icon: ""
  },
  222: {
    label: "Arredamento da esterni",
    icon: ""
  },
  223: {
    label: "Recinto attorno alla piscina",
    icon: ""
  },
  224: {
    label: "Area picnic",
    icon: ""
  },
  225: {
    label: "Camino all'aperto",
    icon: ""
  },
  226: {
    label: "Servizi di bellezza",
    icon: ""
  },
  227: {
    label: "Trattamenti viso",
    icon: ""
  },
  228: {
    label: "Depilazione con ceretta",
    icon: ""
  },
  229: {
    label: "Servizi di make up",
    icon: ""
  },
  230: {
    label: "Trattamenti capelli",
    icon: ""
  },
  231: {
    label: "Manicure",
    icon: ""
  },
  232: {
    label: "Pedicure",
    icon: ""
  },
  233: {
    label: "Taglio capelli",
    icon: ""
  },
  234: {
    label: "Tinta capelli",
    icon: ""
  },
  235: {
    label: "Acconciature",
    icon: ""
  },
  236: {
    label: "Trattamenti corpo",
    icon: ""
  },
  237: {
    label: "Scrub corpo",
    icon: ""
  },
  238: {
    label: "Bendaggi corpo",
    icon: ""
  },
  239: {
    label: "Fototerapia",
    icon: ""
  },
  240: {
    label: "Servizi spa",
    icon: ""
  },
  241: {
    label: "Bagno turco",
    icon: ""
  },
  242: {
    label: "Sala spa area relax",
    icon: ""
  },
  243: {
    label: "Pediluvio",
    icon: ""
  },
  244: {
    label: "Pacchetti spa benessere",
    icon: ""
  },
  245: {
    label: "Massaggi schiena",
    icon: ""
  },
  246: {
    label: "Massaggi collo",
    icon: ""
  },
  247: {
    label: "Massaggi piedi",
    icon: ""
  },
  248: {
    label: "Massaggi di coppia",
    icon: ""
  },
  249: {
    label: "Massaggi testa",
    icon: ""
  },
  250: {
    label: "Massaggi mani",
    icon: ""
  },
  251: {
    label: "Massaggi corpo",
    icon: ""
  },
  252: {
    label: "Poltrona massaggi",
    icon: ""
  },
  253: {
    label: "Fitness",
    icon: ""
  },
  254: {
    label: "Lezioni di yoga",
    icon: ""
  },
  255: {
    label: "Lezioni di fitness",
    icon: ""
  },
  256: {
    label: "Personal trainer",
    icon: ""
  },
  257: {
    label: "Armadietti per fitness spa",
    icon: ""
  },
  258: {
    label: "Piscina per bambini",
    icon: ""
  },
  301: {
    label: "Piscina",
    icon: ""
  },
  302: {
    label: "Spiaggia",
    icon: ""
  },
  304: {
    label: "Servizio navetta",
    icon: ""
  },
  306: {
    label: "Safari classico",
    icon: ""
  },
  400: {
    label: "Mostre d'arte temporanee",
    icon: ""
  },
  401: {
    label: "Giro dei pub",
    icon: ""
  },
  402: {
    label: "Cabaret",
    icon: ""
  },
  403: {
    label: "Serate di cinema",
    icon: ""
  },
  404: {
    label: "Tour a piedi",
    icon: ""
  },
  405: {
    label: "Tour in bicicletta",
    icon: ""
  },
  406: {
    label: "Serate con cene a tema",
    icon: ""
  },
  407: {
    label: "Happy hour",
    icon: ""
  },
  408: {
    label: "Tour o lezioni sulla cultura locale",
    icon: ""
  },
  409: {
    label: "Lezioni di cucina",
    icon: ""
  },
  410: {
    label: "Spettacolo musica dal vivo",
    icon: ""
  },
  411: {
    label: "Trasmissione di eventi sportivi in diretta",
    icon: ""
  },
  412: {
    label: "Tiro con l'arco",
    icon: ""
  },
  413: {
    label: "Aerobica",
    icon: ""
  },
  414: {
    label: "Bingo",
    icon: ""
  },
  418: {
    label: "Sicurezza 24 ore su 24",
    icon: ""
  },
  419: {
    label: "Accesso con chiavi",
    icon: ""
  },
  420: {
    label: "Accesso con chiavi magnetiche",
    icon: ""
  },
  421: {
    label: "Allarme di sicurezza",
    icon: ""
  },
  422: {
    label: "Allarme antifumo",
    icon: ""
  },
  423: {
    label: "Telecamere a circuito chiuso nelle zone in comune",
    icon: ""
  },
  424: {
    label: "Telecamere a circuito chiuso all'esterno della struttura",
    icon: ""
  },
  425: {
    label: "Estintori",
    icon: ""
  },
  431: {
    label: "Bath Hot spring",
    icon: ""
  },
  432: {
    label: "Private bath",
    icon: ""
  },
  433: {
    label: "Piscina",
    icon: ""
  },
  447: {
    label: "Noleggio biciclette",
    icon: ""
  },
  449: {
    label: "Utilizzo di prodotti chimici efficaci contro il Coronavirus",
    icon: ""
  },
  450: {
    label: "Lenzuola, asciugamani e bucato lavati secondo le linee guida delle autorità locali",
    icon: ""
  },
  451: {
    label: "Gli alloggi vengono disinfettati tra un soggiorno e l'altro",
    icon: ""
  },
  452: {
    label: "Gli alloggi vengono sigillati dopo la pulizia",
    icon: ""
  },
  453: {
    label: "Distanziamento fisico nelle zone pasti",
    icon: ""
  },
  454: {
    label: "Il cibo può essere consegnato nell'alloggio",
    icon: ""
  },
  455: {
    label: "Lo staff segue tutti i protocolli di sicurezza indicati dalle autorità locali",
    icon: ""
  },
  456: {
    label: "Sono stati rimossi giornali, menù stampati, penne e fogli in condivisione",
    icon: ""
  },
  457: {
    label: "Gel disinfettante per le mani disponibile negli alloggi e nelle aree comuni",
    icon: ""
  },
  458: {
    label: "Procedure di verifica della salute degli ospiti",
    icon: ""
  },
  459: {
    label: "Kit di pronto soccorso disponibile",
    icon: ""
  },
  460: {
    label: 'Check-in e check-out "contactless" (senza contatto)',
    icon: ""
  },
  461: {
    label: "Pagamenti elettronici disponibili",
    icon: ""
  },
  462: {
    label: "Rispetto delle regole di distanziamento fisico",
    icon: ""
  },
  463: {
    label: "Servizio in camera via app",
    icon: ""
  },
  464: {
    label: "Pannelli o schermi protettivi tra lo staff e gli ospiti in determinate aree",
    icon: ""
  },
  465: {
    label: "Fattura disponibile su richiesta",
    icon: ""
  },
  466: {
    label: "La struttura viene pulita da imprese di pulizie professioniste",
    icon: ""
  },
  467: {
    label: "Piatti, posate, bicchieri e altre stoviglie vengono sterilizzati",
    icon: ""
  },
  468: {
    label: "Gli ospiti possono scegliere di cancellare il servizio di pulizia dell'alloggio durante il soggiorno",
    icon: ""
  },
  484: {
    label: "Colazione in contenitori portatili",
    icon: ""
  },
  485: {
    label: "Cibo consegnato in contenitori coperti",
    icon: ""
  },
  486: {
    label: "Accesso a personale sanitario",
    icon: ""
  },
  487: {
    label: "Termometri forniti dalla struttura",
    icon: ""
  },
  488: {
    label: "Mascherine disponibili per gli ospiti",
    icon: ""
  }
}

export function get_accommodation_facilities(key) {
  const facility = accommodation_facilities[key]
  if (facility) {
   return {
     label: facility.label,
     icon: facility.icon || 'check_circle',
   }
  }
  return {
    name: key,
    icon: "check_circle",
  }
}